import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useLanguage } from '../components/Layout/LanguageContext';

const ImprintSection = styled.section`
  min-height: 100vh;
  padding: 100px 2rem;
  background: var(--background);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled(motion.h1)`
  font-size: 3rem;
  font-weight: 700;
  color: var(--primary);
  margin-bottom: 3rem;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Content = styled(motion.div)`
  background: var(--card-background);
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  line-height: 1.8;
  color: var(--text);
  
  h2 {
    color: var(--primary);
    font-size: 2rem;
    margin: 2rem 0 1rem 0;
    font-weight: 600;
  }
  
  h3 {
    color: var(--secondary);
    font-size: 1.5rem;
    margin: 1.5rem 0 1rem 0;
    font-weight: 500;
  }
  
  p {
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }
  
  ul {
    margin: 1rem 0;
    padding-left: 2rem;
  }
  
  li {
    margin-bottom: 0.5rem;
  }
  
  a {
    color: var(--primary);
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  strong {
    color: var(--primary);
    font-weight: 600;
  }
  
  @media (max-width: 768px) {
    padding: 2rem;
    
    h2 {
      font-size: 1.5rem;
    }
    
    h3 {
      font-size: 1.3rem;
    }
  }
`;

const ImprintDE: React.FC = () => {
  const { setLanguage } = useLanguage();
  
  // Set language to German when component mounts
  React.useEffect(() => {
    setLanguage('de');
  }, [setLanguage]);

  return (
    <ImprintSection>
      <Container>
        <Title>Impressum</Title>
        <Content>
          <h1>Impressum</h1>

          <p>Yannick Reinke<br />
          IT Beratung<br />
          Arnikaweg 2<br />
          87527 Sonthofen</p>

          <h2>Kontakt</h2>
          <p>Telefon: +491604296531<br />
          E-Mail: kontakt@it-beratung-reinke.de</p>
          
          <h2>Angaben zur Berufs&shy;haftpflicht&shy;versicherung</h2>
          <p><strong>Name und Sitz des Versicherers:</strong><br />
          exali AG - Das Versicherungsportal f&uuml;r Dienstleister und freie Berufe<br />
          Franz-Kobinger-Str. 9<br />
          86157 Augsburg</p>
          <p><strong>Geltungsraum der Versicherung:</strong><br />Weltweit</p>

          <h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
          <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
        </Content>
      </Container>
    </ImprintSection>
  );
};

export default ImprintDE;
